import Gateway from '@nsftx/seven-gravity-gateway';

let gateway;
let storeDispatch;

const appLoad = ({ data }) => {
  gateway.sendMessage({
    action: 'Slave.Loaded',
    data: {},
  });

  storeDispatch('SAVE_COMPANY_SETTINGS', data.company || {});
};


export default {
  init({ dispatch }) {
    storeDispatch = dispatch;

    gateway = Gateway.slave({
      debug: true,
      allowedOrigins: '*',
      slaveId: 'PreMatchBettingResults',
      data: {
        title: 'Prematch Betting Results',
      },
      eventPropagation: {
        click: true,
      },
      load: appLoad,
    });
  },
  sendMessage(action, data) {
    if (gateway) gateway.sendMessage({ action, data });
  },
};
